/** HubSpot visitor cookie; used for `context.hutk` and cross-domain transfer. */
export const HUBSPOT_UTK_COOKIE_NAME = "hubspotutk";

export const HUBSPOT_PORTAL_ID =
  process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID || process.env.REACT_APP_HUBSPOT_PORTAL_ID;

export const HUBSPOT_DEFAULT_CONFIG = {
  region: "na1",
  portalId: HUBSPOT_PORTAL_ID,
};

export const HUBSPOT_API_BASE_URL = "https://api.hsforms.com";

export const HUBSPOT_API_ENDPOINTS = {
  submitFormData: `${HUBSPOT_API_BASE_URL}/submissions/v3/integration/submit/:portalId/:formGuid`,
};
